import { logger } from "./log.js";
const log = logger("Binary");
export class Binary {
    constructor(bytes) {
        this.bytes =
            bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
        this.view = new DataView(
            this.bytes.buffer,
            this.bytes.byteOffset,
            this.bytes.byteLength,
        );
    }
    check(offset, size) {
        if (
            !Number.isSafeInteger(offset) ||
            !Number.isSafeInteger(size) ||
            offset < 0 ||
            size < 0 ||
            offset + size > this.bytes.length
        ) {
            log.error("invalid read", new Error("Truncated or invalid binary data"),
                { offset, size, length: this.bytes.length });
            throw new Error("Truncated or invalid binary data");
        }
        return offset;
    }
    u8(o) {
        return this.view.getUint8(this.check(o, 1));
    }
    i8(o) {
        return this.view.getInt8(this.check(o, 1));
    }
    u16(o) {
        return this.view.getUint16(this.check(o, 2), true);
    }
    i16(o) {
        return this.view.getInt16(this.check(o, 2), true);
    }
    u32(o) {
        return this.view.getUint32(this.check(o, 4), true);
    }
    i32(o) {
        return this.view.getInt32(this.check(o, 4), true);
    }
    f32(o) {
        const v = this.view.getFloat32(this.check(o, 4), true);
        if (!Number.isFinite(v)) throw new Error("Non-finite binary float");
        return v;
    }
    vec(o) {
        return [this.f32(o), this.f32(o + 4), this.f32(o + 8)];
    }
    slice(o, n) {
        this.check(o, n);
        return this.bytes.subarray(o, o + n);
    }
    text(o, n) {
        return new TextDecoder().decode(this.slice(o, n));
    }
    string(o, max = 1024) {
        this.check(o, 1);
        let end = o;
        while (end < this.bytes.length && end - o < max && this.bytes[end])
            end++;
        if (end === this.bytes.length || end - o === max)
            throw new Error("Unterminated binary string");
        return this.text(o, end - o);
    }
}
export function canonical(path) {
    const p = path.replaceAll("\\", "/").replace(/[A-Z]/g, c => c.toLowerCase());
    if (
        !p ||
        new TextEncoder().encode(p).length > 512 ||
        /[:\x00-\x1f\x7f-\x9f]/.test(p) ||
        p.split("/").some((s) => !s || s === "." || s === "..")
    )
        throw new Error("Invalid Source asset path");
    return p;
}
export function materialPath(path) {
    path = canonical(path);
    return (path.startsWith("materials/") ? path : `materials/${path}`).replace(
        /(?:\.vmt)?$/,
        ".vmt",
    );
}
export function texturePath(path) {
    path = canonical(path);
    return (path.startsWith("materials/") ? path : `materials/${path}`).replace(
        /(?:\.vtf)?$/,
        ".vtf",
    );
}
